import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reset\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0C18.627 0 24 5.373 24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12C0 5.373 5.373 0 12 0ZM12.98 10.008H10.98V19.008H12.98V10.008ZM10.4465 6.4935C10.4465 5.63552 11.142 4.93999 12 4.93999C12.858 4.93999 13.5535 5.63552 13.5535 6.4935C13.5535 7.35148 12.858 8.04701 12 8.04701C11.142 8.04701 10.4465 7.35148 10.4465 6.4935Z\" fill=\"#3377FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol